import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'portal-signing-decline-modal',
  templateUrl: './signing-decline-modal.component.html',
  styleUrls: ['./signing-decline-modal.component.scss'],
})
export class SigningDeclineModalComponent {
  reason: any;

  constructor(private dialogRef: MatDialogRef<SigningDeclineModalComponent>) {}

  submit(): void {
    this.dialogRef.close({
      isSubmit: true,
      reason: this.reason,
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
